var render = function render(){var _vm=this,_c=_vm._self._c;return _c('board-view',{attrs:{"board-key":"qna"}})
}
var staticRenderFns = []

export { render, staticRenderFns }